import { render, staticRenderFns } from "./DashboardNotIb.vue?vue&type=template&id=fd5a5f16&scoped=true&"
import script from "./DashboardNotIb.vue?vue&type=script&lang=js&"
export * from "./DashboardNotIb.vue?vue&type=script&lang=js&"
import style0 from "./DashboardNotIb.vue?vue&type=style&index=0&id=fd5a5f16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5a5f16",
  null
  
)

export default component.exports